import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setHeaders } from "./baseApiPaths";
import { api_path } from "../../../../environment";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api_path,
    credentials: "include",
    prepareHeaders: setHeaders,
  }),
  keepUnusedDataFor: 30, // 30 s durée de mise en cache des données non utilisées
  // tagTypes:['InfoType'],
  endpoints: () => ({}),
});
